import axios, { AxiosResponse } from "axios";
import { IPortCommunity } from "../models/portCommunity";

export const getPortCommunities = async (): Promise<AxiosResponse<IPortCommunity[]>> => {
    return await axios.get("/dispatcher/portCommunity");
};
